import { saveAs } from 'file-saver';

export function downloadFile(fileData: Blob, fileName: string): void {
	saveAs(fileData, fileName);
}
